module.exports = __webpack_public_path__ + "static/media/icon_137_icon_130_shop_prev_prev.ba685c3f.png";